<template>
    <div class="content" id="chatContentWrp" :class="replyMsgAlertState ? 'reply_msg_for_scroll_height_reduce' : ''">
        <div class="select_user_content">
            <div class="chat_user_content">
                <!-- User Details Here -->
                <div class="contact-profile pl-2">
                    <div class="row align-items-center mr-0" v-if="selectedRoomInfo">
                        <div class="col selected_user_details">
                            <div class="row align-items-center workspace_user_info_link">
                                <div class="col-auto pr-0 hide-chat-box" v-if="isMobile"><i aria-hidden="true"
                                        class="fa fa-arrow-left"
                                        style="font-size: 22px; color: rgb(177, 177, 177);cursor: pointer;"
                                        @click="hideMenuBarOnMblMethod"></i></div>
                                <div class="col-auto usr-photo" style="padding-right:10px;">
                                    <a href="javascript:void(0)" style="cursor:default;">
                                        <!-- <img v-if="selectedRoomInfo.user.profile && selectedRoomInfo.user.profile.thumbnail"
                                            :src="selectedRoomInfo.user.profile.thumbnail" alt="" /> -->
                                        <img src="@/assets/images/user_circle_avtar.png" alt="" />
                                    </a>
                                </div>
                                <div class="col pl-0">
                                    <a href="javascript:void(0)" style="cursor:default;">
                                        <p v-if="selectedRoomInfo.user_info.full_name">
                                            {{ selectedRoomInfo.user_info.full_name }} -
                                            <span>{{ selectedRoomInfo.ticket_number }}</span>
                                        </p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- User Details Here -->

                <div class="messages" id="chatbot_scroll">
                    <div class="chat_msg_list_wrp" id="chat_msg_list_scroll">
                        <div class="extra_space"></div>
                        <div id="reply_msg_list" class="admin_msg_list">
                            <div id="list_of_chat_msg_wrp" class="message_box_of_chat_wrp">
                                <div class="list_msg_of_chat" v-if="selectedRoomInfo">
                                    <ul v-if="chatAllListResults && chatAllListResults.length > 0">
                                        <li v-for="(messageItem, index) in reversedChatListResults"
                                            :id="'chatMessageId' + messageItem.id" class="chat_msg_li" :key="index">
                                            <div v-if="index === 0 || formatDateSeparator(reversedChatListResults[index].updated_at) !== formatDateSeparator(reversedChatListResults[index - 1].updated_at)"
                                                class="msg_date_wrp">
                                                <span class="msg_date_box">
                                                    {{ formatDateSeparator(messageItem.updated_at) }}
                                                </span>
                                            </div>
                                            <div class="message_box_of_chat">
                                                <label class="msg_f_label" v-if="multiMessageOptionEnabled"
                                                    :for="'msg_input' + messageItem.id">
                                                    <input type="checkbox" :id="'msg_input' + messageItem.id"
                                                        :value="messageItem" hidden v-model="multipleMessageArr"
                                                        @click="onchangeOfMsgFrwdMethod(messageItem.id)">
                                                    <span class="custom_checkbox_span">
                                                        <i aria-hidden="true" class="fa fa-check"></i>
                                                    </span>
                                                </label>
                                                <div :class="[getMessageTypeMethod(messageItem)]">
                                                    <!-- Delete Messages Item Code Here -->
                                                    <div class="chat_in_msg_box_wrp delete_msg_show_box"
                                                        v-if="messageItem.delete_for_everyone">
                                                        <span class="chat_msg_content_show">
                                                            <i class="fa fa-ban" aria-hidden="true"></i>
                                                            This message was deleted
                                                        </span>
                                                        <span class="msg_time_wrp" v-if="messageItem">
                                                            <time v-if="messageItem.updated_at"
                                                                class="msg_time">{{ messageItem.updated_at
                                                                |chattimeformat}}</time>
                                                        </span>
                                                    </div>
                                                    <!-- Delete Messages Item Code Here -->
                                                    <div class="chat_in_msg_box_wrp" v-else>
                                                        <!-- Sender Name For Code Here -->
                                                        <template v-if="messageItem.sender_info.id != selfUserId">
                                                            <span class="message_sender_name"
                                                            :style="{color:messageItem.sender.colour}">{{messageItem.sender.first_name}}
                                                            {{messageItem.sender.last_name}}</span>
                                                        </template>
                                                        <!-- Sender Name For Code Here -->
                                                        <!-- Message Features For The Dropdown Code Here -->
                                                        <!-- <div class="dropdown">
                                                            <span class="msg_toggle_option" data-toggle="dropdown"><i
                                                                    class="fa fa-chevron-down"
                                                                    aria-hidden="true"></i></span>
                                                            <ul class="dropdown-menu">
                                                                <li v-on:click="replyMessageOnChatMethod(messageItem)">
                                                                    Reply</li>
                                                                <li @click="forwardMsgToUserMethod(messageItem)">
                                                                    Forward Message</li>
                                                                <li
                                                                    @click="deteteMessageFromChatMethod(messageItem.id, messageItem.message, messageItem.updated_at, messageItem.sender_info.id)">
                                                                    Delete Message</li>
                                                            </ul>
                                                        </div> -->
                                                        <!-- Message Features For The Dropdown Code Here -->
                                                        <!-- Forward Messages For Code Here -->
                                                        <template v-if="messageItem.forwarded">
                                                            <span class="forwarded_msg_text">
                                                                <i class="fa fa-share" aria-hidden="true"></i>
                                                                <span>Forwarded</span>
                                                            </span>
                                                            <template v-if="messageItem.forwarded_from">
                                                                <span class="msg_in_file"
                                                                    v-if="messageItem.forwarded_from.file">
                                                                    <span
                                                                        v-if="isImageFile(messageItem.forwarded_from.file)"
                                                                        class="msg_img_render_in_chat">
                                                                        <a :href="messageItem.forwarded_from.file"
                                                                            target="_new"
                                                                            v-on:click.prevent="fileOpenNewTab(messageItem.forwarded_from.file)">
                                                                            <img :src="messageItem.forwarded_from.file"
                                                                                alt="" class="img-fluid">
                                                                        </a>
                                                                    </span>
                                                                    <span class="msg_file_render_in_chat" v-else>
                                                                        <a :href="messageItem.forwarded_from.file"
                                                                            target="_new"
                                                                            v-on:click.prevent="fileOpenNewTab(messageItem.forwarded_from.file)">
                                                                            <img :src="checkFileExtensionForChatMessage(messageItem.forwarded_from.file)"
                                                                                alt="" class="img-fluid">
                                                                            <span
                                                                                class="msg_file_name">{{ getFileName(messageItem.forwarded_from.file) }}</span>
                                                                        </a>
                                                                    </span>
                                                                </span>
                                                                <span class="chat_msg_content_show"
                                                                    v-if="messageItem.forwarded_from.message">
                                                                    <span class="show_msg_of_reply_wrp"
                                                                        v-if="messageItem.forwarded_from.reply_to_msg"
                                                                        :style="{ 'border-left-color': messageItem.forwarded_from.sender.colour + '!important' }">
                                                                        <span class="show_msg_of_reply_name"
                                                                            :style="{ color: messageItem.forwarded_from.sender.colour }">
                                                                            {{ messageItem.forwarded_from.sender.first_name }}
                                                                            {{ messageItem.forwarded_from.sender.last_name }}
                                                                        </span>
                                                                        <span class="show_msg_of_reply_txt"
                                                                            v-if="messageItem.forwarded_from.reply_to_msg.message"
                                                                            v-html="messageItem.forwarded_from.reply_to_msg.message">
                                                                        </span>
                                                                        <span class="show_msg_of_reply_txt" v-else>
                                                                            <a :href="messageItem.forwarded_from.reply_to_msg.file"
                                                                                target="_new">{{ messageItem.forwarded_from.reply_to_msg.data.filename }}</a>
                                                                        </span>
                                                                    </span>
                                                                    <span class="msg_link"
                                                                        v-html="urlify(messageItem.forwarded_from.message)"></span>
                                                                </span>
                                                            </template>
                                                        </template>
                                                        <!-- Forward Messages For Code Here -->
                                                        <template v-else>
                                                            <span class="msg_in_file" v-if="messageItem.file">
                                                                <span v-if="isImageFile(messageItem.file)"
                                                                    class="msg_img_render_in_chat">
                                                                    <a :href="messageItem.file" target="_new"
                                                                        @click="fileOpenNewTab(messageItem.file)">
                                                                        <img :src="messageItem.file" alt=""
                                                                            class="img-fluid">
                                                                    </a>
                                                                </span>
                                                                <span class="msg_file_render_in_chat" v-else>
                                                                    <a :href="messageItem.file" target="_new"
                                                                        @click="fileOpenNewTab(messageItem.file)">
                                                                        <img :src="checkFileExtensionForChatMessage(messageItem.file)"
                                                                            alt="" class="img-fluid">
                                                                        <span class="msg_file_name">{{
                                                                            getFileName(messageItem.file) }}</span>
                                                                    </a>
                                                                </span>
                                                            </span>
                                                            <span class="chat_msg_content_show"
                                                                v-if="messageItem.message">
                                                                <span class="show_msg_of_reply_wrp"
                                                                    v-if="messageItem.reply_to_msg"
                                                                    :style="{ 'border-left-color': messageItem.sender.colour + '!important' }">
                                                                    <span class="show_msg_of_reply_name"
                                                                        :style="{ color: messageItem.sender.colour }">
                                                                        {{ messageItem.sender.first_name }}
                                                                        {{ messageItem.sender.last_name }}
                                                                    </span>
                                                                    <template v-if="messageItem.reply_to_msg">
                                                                        <template
                                                                            v-if="messageItem.reply_to_msg.forwarded">
                                                                            <span class="show_msg_of_reply_txt"
                                                                                v-if="messageItem.reply_to_msg.forwarded_from.message"
                                                                                v-html="messageItem.reply_to_msg.forwarded_from.message">
                                                                            </span>
                                                                            <span class="show_msg_of_reply_txt"
                                                                                v-else-if="messageItem.reply_to_msg.forwarded_from.file">
                                                                                <a :href="messageItem.reply_to_msg.forwarded_from.file"
                                                                                    target="_new">{{
                                                                                    getFileName(messageItem.reply_to_msg.forwarded_from.file)
                                                                                    }}</a>
                                                                            </span>
                                                                        </template>
                                                                        <span class="show_msg_of_reply_txt"
                                                                            v-else-if="messageItem.reply_to_msg.message"
                                                                            v-html="messageItem.reply_to_msg.message">
                                                                        </span>
                                                                        <span class="show_msg_of_reply_txt" v-else>
                                                                            <a :href="messageItem.reply_to_msg.file"
                                                                                target="_new">{{
                                                                                getFileName(messageItem.reply_to_msg.file)
                                                                                }}</a>
                                                                        </span>
                                                                    </template>
                                                                </span>
                                                                <span class="msg_link"
                                                                    v-html="urlify(messageItem.message)"></span>
                                                            </span>
                                                        </template>
                                                        <!-- Messages Timestamp For Code Here -->
                                                        <span class="msg_time_wrp">
                                                            <time v-if="messageItem.updated_at"
                                                                class="msg_time">{{ messageItem.updated_at
                                                                |chattimeformat}}</time>
                                                            <label class="chat_msg_send_received_action_wrp">
                                                                <!-- <template
                                                                    v-if="getMessageStatusMethod(messageItem.message_statuses) == 'read'">
                                                                    <i class="msg_indication msg_read_ind"
                                                                        aria-hidden="true"></i>
                                                                </template>
                                                                <template
                                                                    v-else-if="getMessageStatusMethod(messageItem.message_statuses) == 'delivered'">
                                                                    <i class="msg_indication msg_sent_ind"
                                                                        aria-hidden="true"></i>
                                                                </template>
                                                                <template v-else>
                                                                    <i class="msg_indication msg_unsent_ind"
                                                                        aria-hidden="true"></i>
                                                                </template> -->
                                                                <template v-if="messageItem.is_read_by_user">
                                                                    <i class="msg_indication msg_read_ind"
                                                                        aria-hidden="true"></i>
                                                                </template>
                                                                <template v-else>
                                                                    <i class="msg_indication msg_unsent_ind"
                                                                        aria-hidden="true"></i>
                                                                </template>
                                                            </label>
                                                        </span>
                                                        <!-- Messages Timestamp For Code Here -->
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Selected Room For Messages List Here -->
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <template v-if="typingUserInfoState">
                            <div class="typing_dots_wrp" v-if="typingUserInfoState.ChatRoomId == selectedRoomInfo.ticket_number">
                                <!-- {{ this.chatScrollBottomMethod() }} -->
                                <img src="@/assets/images/loading_dots.gif" height="30">
                            </div>
                        </template>
                        <div class="fixloader listLoading msgloader" v-if="msgApiLoader">
                            <div class="spinner spinner-1"></div>
                        </div>
                    </div>
                </div>
                <!-- Messsage Details Here -->
                <div class="msg_file_wrp" v-if="uploadFile">
                    <div class="msg_file_top_wrp">
                        <span class="msg_file_popup_close"><i class="fa fa-window-close" aria-hidden="true"
                                @click="cancelUploadFile"></i></span>
                        <span class="uploaded_file_name">{{ filename }}</span>
                    </div>
                    <div class="uploaded_file_preview">
                        <img :src="imgSrc" alt="" class="img-fluid" v-if="imgSrc != ''">
                        <img :src="checkFileExtension(filename)" alt="" class="img-fluid" v-else>
                    </div>
                    <div class="message-input">
                        <div class="file_send_in_msg_wrp">
                            <form @submit.prevent="fileMsgSubmitMethod" enctype="multipart/form-data" novalidate>
                                    <textarea type="text" autocomplete="off" name="fileMessage" v-model="fileMessage"
                                        id="textarea_for_file_input" placeholder="Type a message..."></textarea>
                                <button class="submit">
                                    <svg width="57px" height="54px" viewBox="1496 193 57 54" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        style="width: 18px; height: 18px;">
                                        <g id="Group-9-Copy-3" stroke="none" stroke-width="1" fill="none"
                                            fill-rule="evenodd"
                                            transform="translate(1523.000000, 220.000000) rotate(-270.000000) translate(-1523.000000, -220.000000) translate(1499.000000, 193.000000)">
                                            <path data-v-77c07480=""
                                                d="M5.42994667,44.5306122 L16.5955554,44.5306122 L21.049938,20.423658 C21.6518463,17.1661523 26.3121212,17.1441362 26.9447801,20.3958097 L31.6405465,44.5306122 L42.5313185,44.5306122 L23.9806326,7.0871633 L5.42994667,44.5306122 Z M22.0420732,48.0757124 C21.779222,49.4982538 20.5386331,50.5306122 19.0920112,50.5306122 L1.59009899,50.5306122 C-1.20169244,50.5306122 -2.87079654,47.7697069 -1.64625638,45.2980459 L20.8461928,-0.101616237 C22.1967178,-2.8275701 25.7710778,-2.81438868 27.1150723,-0.101616237 L49.6075215,45.2980459 C50.8414042,47.7885641 49.1422456,50.5306122 46.3613062,50.5306122 L29.1679835,50.5306122 C27.7320366,50.5306122 26.4974445,49.5130766 26.2232033,48.1035608 L24.0760553,37.0678766 L22.0420732,48.0757124 Z"
                                                id="sendicon" fill="#ffffff" fill-rule="nonzero"></path>
                                        </g>
                                    </svg>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Messsage Details Here -->
            </div>
            <div class="message-input" v-if="selectedRoomInfo">
                <div class="forward_msg_action" v-if="multiMessageOptionEnabled">
                    <div class="row">
                        <div class="col-sm-6">
                            <span class="forward_s_cross mr-2"><i class="fa fa-close" aria-hidden="true"
                                    @click="clearMultipleMsgDataMethod"></i></span>
                            <span class="f_m_selected">{{ multipleMessageArr.length }} selected</span>
                        </div>
                        <div class="col-sm-6 text-right" v-if="multipleMessageArr.length > 0">
                            <i class="fa fa-share mr-4" aria-hidden="true" @click="forwardMultipleMsgToUserMethod"></i>
                        </div>
                    </div>
                </div>
                <div class="wrap">
                    <div class="reply_msg_detail_view_wrp" v-if="replyMsgAlertState">
                        <div class="row align-items-center">
                            <div class="col-11">
                                <div class="reply_msg_data_wrp" v-if="replyMsgDataObj">
                                    <div class="reply_msg_send_status">
                                        <div class="reply_msg_un">
                                            <span class="message_sender_name">{{ replyMsgDataObj.data.sender.first_name }}
                                                {{ replyMsgDataObj.data.sender.last_name }}</span>
                                        </div>
                                        <div class="reply_msg_txt">
                                            <template v-if="replyMsgDataObj.data.forwarded">
                                                <span class="chat_msg_content_show"
                                                    v-if="replyMsgDataObj.data.forwarded_from.message"
                                                    v-html="replyMsgDataObj.data.forwarded_from.message">
                                                </span>
                                                <span class="show_msg_of_reply_txt"
                                                    v-else-if="replyMsgDataObj.data.forwarded_from.file">
                                                    <a :href="replyMsgDataObj.data.forwarded_from.file" target="_new">{{
                                                        getFileName(replyMsgDataObj.data.forwarded_from.file) }}</a>
                                                </span>
                                            </template>
                                            <span class="chat_msg_content_show" v-else-if="replyMsgDataObj.data.message"
                                                v-html="replyMsgDataObj.data.message"></span>
                                            <span class="show_msg_of_reply_txt" v-else>
                                                <a :href="replyMsgDataObj.data.file" target="_new">{{
                                                    getFileName(replyMsgDataObj.data.file) }}</a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-1 ml-auto">
                                <span class="reply_msg_data_close">
                                    <img src="@/assets/images/close.png" class="img-fluid"
                                        v-on:click="cancelReplyMessageOnChatMethod">
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="message_insert_box">
                        <textarea v-model="messageContentDraftValue" type="text" autocomplete="off"
                            id="chat-message-reply-input" placeholder="Type a message..."
                            v-if="selection_type == 'click_send'" class="click_send regular-input"></textarea>
                        <textarea v-model="messageContentDraftValue" type="text" autocomplete="off"
                            id="chat-message-reply-input" placeholder="Type a message..." @keydown.enter.exact.prevent
                            @keyup.enter.exact="send" @keydown.enter.shift.exact="newline" v-else
                            class="press_enter regular-input"></textarea>
                        <emoji-picker @emoji="insertEmojiMethod">
                            <button class="emoji-invoker" slot="emoji-invoker"
                                slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                    class="h-6 w-6 fill-current text-grey">
                                    <path d="M0 0h24v24H0z" fill="none" />
                                    <path
                                        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
                                </svg>
                            </button>
                            <div slot="emoji-picker" slot-scope="{ emojis, insert }" class="emoji-picker-main-div">
                                <div class="emoji-picker">
                                    <div>
                                        <div v-for="(emojiGroup, category) in emojis" :key="category"
                                            :class="category == 'Frequently used' ? 'd-block' : 'd-none'">
                                            <div class="emojis">
                                                <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName"
                                                    @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </emoji-picker>
                    </div>
                    <div class="option_btn_wrp">
                        <button class="submit" id="chat-message-reply-submit">
                            <svg width="57px" height="54px" viewBox="1496 193 57 54" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                style="width: 18px; height: 18px;">
                                <g id="Group-9-Copy-3" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                    transform="translate(1523.000000, 220.000000) rotate(-270.000000) translate(-1523.000000, -220.000000) translate(1499.000000, 193.000000)">
                                    <path data-v-77c07480=""
                                        d="M5.42994667,44.5306122 L16.5955554,44.5306122 L21.049938,20.423658 C21.6518463,17.1661523 26.3121212,17.1441362 26.9447801,20.3958097 L31.6405465,44.5306122 L42.5313185,44.5306122 L23.9806326,7.0871633 L5.42994667,44.5306122 Z M22.0420732,48.0757124 C21.779222,49.4982538 20.5386331,50.5306122 19.0920112,50.5306122 L1.59009899,50.5306122 C-1.20169244,50.5306122 -2.87079654,47.7697069 -1.64625638,45.2980459 L20.8461928,-0.101616237 C22.1967178,-2.8275701 25.7710778,-2.81438868 27.1150723,-0.101616237 L49.6075215,45.2980459 C50.8414042,47.7885641 49.1422456,50.5306122 46.3613062,50.5306122 L29.1679835,50.5306122 C27.7320366,50.5306122 26.4974445,49.5130766 26.2232033,48.1035608 L24.0760553,37.0678766 L22.0420732,48.0757124 Z"
                                        id="sendicon" fill="#ffffff" fill-rule="nonzero"></path>
                                </g>
                            </svg>
                        </button>
                        <div class="option_btn_icon_wrp">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#ffffff" width="24"
                                height="24" focusable="false" v-on:click="messageFeatureStatesMethod()"
                                :class="messageFeatureStates ? 'actv_btn' : ''">
                                <path
                                    d="M14 12a2 2 0 11-2-2 2 2 0 012 2zM4 10a2 2 0 102 2 2 2 0 00-2-2zm16 0a2 2 0 102 2 2 2 0 00-2-2z">
                                </path>
                            </svg>
                            <div class="option_btn_content_wrp" v-if="messageFeatureStates">
                                <ul>
                                    <li>
                                        <input type="radio" id="press_enter" name="type" v-model="selection_type"
                                            value="press_enter" v-on:click="selectedOptionMethod('press_enter')">
                                        <label for="press_enter"
                                            :class="selection_type == 'press_enter' ? 'active' : ''">
                                            <span class="option_content_heading">Press Enter to Send</span>
                                            <span class="option_content_normal_txt">Pressing Enter will send
                                                message</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input type="radio" id="click_send" name="type" v-model="selection_type"
                                            value="click_send" v-on:click="selectedOptionMethod('click_send')">
                                        <label for="click_send" :class="selection_type == 'click_send' ? 'active' : ''">
                                            <span class="option_content_heading">Click Send</span>
                                            <span class="option_content_normal_txt">Clicking Send will send
                                                message</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blank_message_input_box" v-else></div>
        </div>
        <div class="fixloader listLoading" v-if="listLoading">
            <percentageLoader :uploadProgressState="uploadProgress" v-if="uploadProgress > 0 && submitted">
            </percentageLoader>
        </div>
        <!-- Not Connected User Popup -->
        <msg-delete-popup v-if="deleteMsgPopupState" v-bind:deleteMessageDataOBJ="deleteMessageDataObj"
            :roomSocketUrl="chatSocketMethod"></msg-delete-popup>
        <!-- Selected Message Delete Popup Code Here -->
        <!-- Forward Message Popup Code Here -->
        <forwardMsgPopup v-if="forwardMsgPopup" :forwardMsgInfo="multipleMessageArr" :roomSocketUrl="chatSocketMethod"
            :chatRoomInfo="selectedRoomInfo">
        </forwardMsgPopup>
        <!-- Forward Message Popup Code Here -->
    </div>
</template>

<script>
/*eslint-disable */

import EmojiPicker from 'vue-emoji-picker';
import axios from 'axios';
import { bus } from '@/main';
import commonSocketConnectMethod from "@/commonSocket";
import { mapGetters } from 'vuex';
import moment from 'moment';
import responsiveMixin from '@/mixins/responsive';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

var pingInterval;

// Lazy load components
const percentageLoader = () => import('@/components/common/percentage-loader-f-file/');
const msgDeletePopup = () => import('@/components/private/workspace/msg-delete-popup/');
const forwardMsgPopup = () => import('@/components/private/workspace/support-chat-forward-msg-popup/');

let UploadMsgFileURL = root.uploadMsgFileUrl.link;

const $ = window.jQuery = require('jquery');
export default {
    name: 'support-chat-info-section',
    mixins: [responsiveMixin],
    components: {
        'msg-delete-popup': msgDeletePopup,
        forwardMsgPopup,
        percentageLoader,
        EmojiPicker,
    },
    props: ['selectedChatRoomData'],
    directives: {
        focus: {
            inserted(el) {
                el.focus()
            },
        },
    },
    data() {
        return {
            selectedRoomInfo: null,
            message: '',
            submitted: false,
            selfUserInfo: null,
            chatSocketMethod: null,
            listLoading: false,
            blockedUserId: '',
            blockedUserEmail: '',
            uploadFile: null,
            filename: '',
            imgSrc: '',
            fileMessage: '',
            msgNextPageLoader: '',
            selectedActvRoomId: '',
            chatAllListResults: [],
            msgApiLoader: false,
            msgValue: '',
            selfUserId: localStorage.getItem('LoginedUserID'),
            selection_type: 'press_enter',
            messageFeatureStates: false,
            deleteMessageDataObj: {
                id: '',
                text: '',
                time: '',
                createdBy: '',
                roomId: '',
            },
            deleteMsgPopupState: false,
            replyMsgDataObj: {
                data: ''
            },
            replyMsgAlertState: false,
            messageIdForReply: '',
            forwardMsgPopup: false,
            messageContentDraftValue: '',
            typingUserInfoState: null,
            messageListResultsDto: null,
            multipleMessageArr: [],
            multiMessageOptionEnabled: false,
            uploadProgress: 0,
            search: '',
            emojis: ["👍", "👎", "😭", "😕", "😐", "😊", "😍",],
            typingTimeout: null,
            lastLiveMsgData: null
        }
    },
    computed: {
        ...mapGetters([
            'acUserDetailsStateGetters'
        ]),
        getSelfUserInfo() {
            this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data;
            return;
        },
        getSelectedChatRoomInfo() {
            return this.selectedChatRoomData;
        },
        reversedChatListResults() {
            return [...this.chatAllListResults];
        },
    },
    mounted() {
        if (this.selectedChatRoomData) {
            this.selectedRoomInfo = this.selectedChatRoomData;
            this.buildChatRoomMethod(this.selectedChatRoomData);
        }

        this.getSelfUserInfo;

        // Router Leave Of The Workspace Event Listener
        bus.$on('supportWorkspaceRouterLeaveEvntBus', (data) => {
            if (data == "Router_leave") {
                this.chatWebSocketClosedFroceMethod();
            }
        })

        // Typing For Selected User Event Listener
        bus.$on('typingEventForChatBus', (data) => {
            this.typingUserInfoState = data;
            if (data.message == 'stop') {
                this.typingUserInfoState = null;
            }
        })
        // Assuming 'bus' is an existing event bus or custom event dispatcher
        bus.$on('MessageDeleteForChatOfAllNotification', (data) => {
            const chatMessageElement = document.getElementById('chatMessageId' + data.id);
            if (chatMessageElement) {
                const dropdown = chatMessageElement.querySelector('.dropdown');
                if(dropdown){
                dropdown.remove();
                }
                const replyWrapper = chatMessageElement.querySelector('.show_msg_of_reply_wrp');
                if(replyWrapper){
                replyWrapper.remove();
                }
                const label = chatMessageElement.querySelector('label');
                if(label){
                label.remove();
                }
                const sender = chatMessageElement.querySelector('.message_sender_name');
                if(sender){
                 sender.remove();
                }
                const chatMsgBoxWrp = chatMessageElement.querySelector('.chat_in_msg_box_wrp');
                if(chatMsgBoxWrp){
                chatMsgBoxWrp.classList.add('delete_msg_show_box');
                const msgInFile = chatMessageElement.querySelector('.msg_in_file');
                if(msgInFile){
                    msgInFile.style.color = "#4c4c4c";
                    msgInFile.innerHTML = "<i aria-hidden='true' class='fa fa-ban'></i> This message was deleted";
                }else{
                    const anchorTag = chatMsgBoxWrp.querySelector('span');
                    anchorTag.style.color = "#4c4c4c";
                    anchorTag.innerHTML = "<i aria-hidden='true' class='fa fa-ban'></i> This message was deleted";
                }
                }
            }
        });

        // Enter Loader Hide Code Here
        var _self = this
        $('#chat_msg_list_scroll').on("scroll", function () {
            var yScrollHeight;
            var elmntList = document.getElementById("chat_msg_list_scroll");
            yScrollHeight = elmntList.scrollHeight;
            if (0 == $('#chat_msg_list_scroll').scrollTop()) {
                if (_self.msgNextPageLoader) {
                    _self.msgApiLoader = true;
                    axios.get(_self.msgNextPageLoader).then((response) => {
                        _self.msgNextPageLoader = '';
                        if (response.status == '200') {
                            _self.msgNextPageLoader = response.data.data.next;
                            _self.msgApiLoader = false;
                            _self.chatAllListResults = [].concat(_self.chatAllListResults, response.data.data.results);
                            setTimeout(() => {
                                let recentScrlHeight = elmntList.scrollHeight;
                                elmntList.scrollTop = recentScrlHeight - yScrollHeight;
                            }, 10)
                        }
                    }).catch((err) => { })
                }
            }
        });
        bus.$on('deleteMsgPopupStateBus', (data) => {
            this.deleteMsgPopupState = data;
        })
        bus.$on('forwardMsgPopupBus', (data) => {
            $('.live_msg_f_label').removeClass('d-block');
            $('.chat_msg_li').removeClass('selected');
            $('.live_msg').removeClass('selected');
            this.forwardMsgPopup = data;
            this.multiMessageOptionEnabled = false;
            this.multipleMessageArr = [];
        })
    },
    methods: {
        isImageFile(filePath) {
            const imageExtensions = ['png', 'jpeg', 'jpg', 'svg', 'gif', 'webp'];
            const fileExtension = filePath.split('.').pop().toLowerCase();
            let extension = fileExtension.substring(0, fileExtension.lastIndexOf("?"));
            return imageExtensions.includes(extension);
        },
        getFileName(filePath) {
            return filePath.split('/').pop().split('?')[0];
        },
        chatWebSocketClosedFroceMethod() {
            if (this.chatSocketMethod) {
                this.chatSocketMethod.close();
            }
        },
        hideMenuBarOnMblMethod() {
            this.chatWebSocketClosedFroceMethod();
            this.selectedActvRoomId = '';
            // Get the element with id 'sidepanel'
            const sidepanel = document.getElementById('sidepanel');
            if (sidepanel) {
                sidepanel.classList.remove('d-none');
            }

            // Get the element with id 'chatContentWrp'
            const chatContentWrp = document.getElementById('chatContentWrp');
            if (chatContentWrp) {
                chatContentWrp.classList.remove('d-block');
            }
            document.querySelectorAll('.chat_user_listed').forEach((element) => {
                element.classList.remove('active');
            });
            // Remove old live messages (consider Vue's reactivity more, but fallback is fine)
            if ($ && typeof $.fn.remove === 'function') {
                $('.live_msg').remove();
            } else {
                // console.warn("jQuery not available or .remove() not a function. Cannot remove '.live_msg' elements.");
                document.querySelectorAll('.live_msg').forEach(el => el.remove());
            }
            bus.$emit('hideChatSectionInMblBus', true);
        },
        getMessageStatusMethod(messageStatus) {
            if (!messageStatus) return;
            const allRead = messageStatus.every(status => status.is_read);
            const allDelivered = messageStatus.every(status => status.is_delivered);
            if (allRead) {
                return 'read';
            } else if (allDelivered) {
                return 'delivered';
            } else {
                return 'undelivered';
            }
        },
        formatTimestamp(timestamp) {
            const date = new Date(timestamp);
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        },

        formatDateSeparator(timestamp) {
            const date = new Date(timestamp);
            const options = { month: 'long', day: 'numeric' };
            return date.toLocaleDateString(undefined, options);
        },
        insertEmojiMethod(emoji) {
            this.messageContentDraftValue += emoji
        },
        /*
         * This Will Check Blocked User Method Here End
         */
        selectedOptionMethod(item) {
            this.selection_type = item;
            this.messageFeatureStates = false;
        },
        messageFeatureStatesMethod() {
            if (this.messageFeatureStates) {
                this.messageFeatureStates = false;
            } else {
                this.messageFeatureStates = true;
                var _self = this
                $(document).click(function (event) {
                    //if you click on anything except the modal itself or the "open modal" link, close the modal
                    if (!$(event.target).closest(".option_btn_wrp").length) {
                        _self.messageFeatureStates = false
                    }
                });
            }
        },
        /*
         * This Methods Code Start For Chat Room Specific
         */
        enabledYearDateFun(msgDateTime) {
            var currentLocalDate = moment().format('YYYY');
            var startDateCheck = moment(msgDateTime).format('YYYY');
            if (currentLocalDate > startDateCheck) {
                return true;
            } else {
                return false;
            }
        },
        newline() { },
        send() { },
        /*
         * This Methods Code End For Chat Room Specific
         */
        getURLObj() {
            return window.URL || window.webkitURL;
        },
        captureImgOnPasteMethod(e) {
            if (e.clipboardData && e.clipboardData.items) {
                var items = e.clipboardData.items;
                for (var i = 0; i < items.length; i++) {
                    if (items[i].type.indexOf('image') !== -1) {
                        var blob = items[i].getAsFile();
                        var URLObj = this.getURLObj();
                        var source = URLObj.createObjectURL(blob);
                        this.uploadFile = blob;
                        this.imgSrc = source;
                        this.filename = 'Photo';
                        e.preventDefault();
                    }
                }
            }
        },
        urlify(text) {
            var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
            return text.replace(urlRegex, function (url, b, c) {
                var url2 = (c == 'www.') ? 'http://' + url : url;
                return '<a href="' + url2 + '" target="_blank" class="hyper_link">' + url + '</a>';
            })
        },
        forwardMsgCheckboxMethod(message, id) {
            let e = document.getElementById('msg_input' + id).parentNode;
            let $label = e.parentNode;
            if (document.getElementById('msg_input' + id).checked == false) {
                this.removeObjectWithIdFromForwardMessageMethod(id);
            } else {
                this.multipleMessageArr.push(message);
            }
            if ($label.classList.contains("selected")) {
                $label.classList.remove("selected");
            } else {
                $label.classList.add("selected");
            }
        },
        removeObjectWithIdFromForwardMessageMethod(id) {
            const objWithIdIndex = this.multipleMessageArr.findIndex((obj) => obj.chat_data.message_id === id);
            if (objWithIdIndex > -1) {
                this.multipleMessageArr.splice(objWithIdIndex, 1);
            }
            return this.multipleMessageArr;
        },
        onchangeOfMsgFrwdMethod(id) {
            let e = document.getElementById('msg_input' + id).parentNode
            let $label = e.parentNode
            if ($label.classList.contains("selected")) {
                $label.classList.remove("selected");
            } else {
                $label.classList.add("selected");
            }
        },
        forwardLiveMsgToUserMethod(item) {
            $('.live_msg_f_label').addClass('d-block');
            this.multipleMessageArr.push(item);
            document.getElementById('msg_input' + item.id).checked = true;
            this.multiMessageOptionEnabled = true;
            let messageInputDom = document.querySelector('#chat-message-reply-input');
            messageInputDom.value = '';
            this.messageContentDraftValue = '';
            setTimeout(() => {
                this.onchangeOfMsgFrwdMethod(item.id);
            }, 100)
        },
        forwardMsgToUserMethod(item) {
            $('.live_msg_f_label').addClass('d-block');
            this.multipleMessageArr.push(item);
            this.multiMessageOptionEnabled = true;
            let messageInputDom = document.querySelector('#chat-message-reply-input');
            messageInputDom.value = '';
            this.messageContentDraftValue = '';
            setTimeout(() => {
                this.onchangeOfMsgFrwdMethod(item.id);
            }, 100)
        },
        clearMultipleMsgDataMethod() {
            $('.live_msg_f_label').removeClass('d-block');
            $('.chat_msg_li').removeClass('selected');
            $('.live_msg').removeClass('selected');
            this.multiMessageOptionEnabled = false;
            this.multipleMessageArr = [];
        },
        forwardMultipleMsgToUserMethod() {
            this.forwardMsgPopup = true;
        },
        /*
         * This Will Reply Selected Message From Chat
        */
        replyMessageOnChatMethod(msgData) {
            this.replyMsgDataObj.data = msgData;
            this.replyMsgAlertState = true;
            this.messageIdForReply = msgData.id;
            document.getElementById("chat-message-reply-input").focus();
        },

        cancelReplyMessageOnChatMethod() {
            this.messageIdForReply = '';
            this.replyMsgDataObj.data = '';
            this.replyMsgAlertState = false;
        },
        /*
         * This Will Delete Selected Message From Chat
        */
        deteteMessageFromChatMethod(messageId, MsgText, messageTime, createdBy) {
            this.deleteMessageDataObj.id = messageId;
            this.deleteMessageDataObj.time = messageTime;
            this.deleteMessageDataObj.text = MsgText;
            this.deleteMessageDataObj.createdBy = createdBy;
            this.deleteMessageDataObj.roomId = this.selectedRoomInfo.ticket_number;
            this.deleteMsgPopupState = true;
        },
        /*
         * This Will Scroll Bottom Of ChatBox
        */
        chatScrollBottomMethod() {
            var elmnt = document.getElementById("chat_msg_list_scroll");

            if (!elmnt) {
                console.warn("Element with ID 'chat_msg_list_scroll' not found.");
                return;
            }

            var scrollHeight = elmnt.scrollHeight;
            var clientHeight = elmnt.clientHeight;
            var scrollTop = elmnt.scrollTop;
            var distanceFromBottom = scrollHeight - (clientHeight + scrollTop);
            var scrollHeightTotal = (distanceFromBottom + clientHeight + scrollTop);
            elmnt.scrollTop = scrollHeightTotal;
        },
        /*
         * This Will Checking Chat Message Position 
        */
        getMessageTypeMethod(chatData) {
            if (!chatData) return;
            if (chatData.sender) {
                if (chatData.sender_info.id == this.selfUserId) {
                    return 'recieved';
                } else {
                    return 'sent';
                }
            }
        },
        /*
         * this will check the new message notification
        */
        playSound(sound) {
            if (sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },

        /*
         * this will get All Message List again
        */
        allMessageListMethod() {
            this.$store.dispatch('getUserChatDetailsByIdFun', {
                id: this.selectedRoomInfo.ticket_number
            }).then((response) => {
                this.messageListResultsDto = response.data.data;
                this.chatAllListResults = [].concat(response.data.data.results);
                this.msgNextPageLoader = response.data.data.next;
                // Remove old live messages (consider Vue's reactivity more, but fallback is fine)
                if ($ && typeof $.fn.remove === 'function') {
                    $('.live_msg').remove();
                } else {
                    // console.warn("jQuery not available or .remove() not a function. Cannot remove '.live_msg' elements.");
                    document.querySelectorAll('.live_msg').forEach(el => el.remove());
                }
                this.lastLiveMsgData = null; // Reset lastLiveMsgData to null
            })
        },
        /*
         * This Will Opned Chat Room With Selected user Of Contact List Method Here
         */
        buildChatRoomMethod(chatRoomInfo) {
            const token = localStorage.getItem('token');
            this.selectedRoomInfo = chatRoomInfo;
            const roomId = chatRoomInfo.ticket_number;

            // Reset UI states immediately
            this.lastLiveMsgData = null;
            this.messageContentDraftValue = '';
            this.cancelReplyMessageOnChatMethod();

            // Only proceed with room-specific actions if the room has truly changed
            if (this.selectedActvRoomId !== roomId) {

                // 1. --- IMPORTANT: Close existing WebSocket connection before opening a new one ---
                if (this.chatSocketMethod && this.chatSocketMethod.readyState === WebSocket.OPEN) {
                    this.chatSocketMethod.close();
                    this.chatSocketMethod = null; // Clear the reference
                }
                // Also clear any pending typing timeout from the previous room
                if (this.typingTimeout) {
                    clearTimeout(this.typingTimeout);
                    this.typingTimeout = null;
                }

                this.selectedActvRoomId = roomId;
                this.msgNextPageLoader = '';
                this.messageListResultsDto = null;
                this.chatAllListResults = [];

                // Remove old live messages (consider Vue's reactivity more, but fallback is fine)
                if ($ && typeof $.fn.remove === 'function') {
                    $('.live_msg').remove();
                } else {
                    // console.warn("jQuery not available or .remove() not a function. Cannot remove '.live_msg' elements.");
                    document.querySelectorAll('.live_msg').forEach(el => el.remove());
                }

                const chatRoomSocketId = chatRoomInfo.id.replace(/-/g, "");

                this.$store.dispatch('botMessagesListAction', {
                    id: chatRoomInfo.ticket_number
                }).then((response) => {
                    this.messageListResultsDto = response.data.data;
                    this.chatAllListResults = [].concat(response.data.data.results);
                    this.msgNextPageLoader = response.data.data.next;
                    bus.$emit('unreadCountClearedForUserBus', true);

                    this.$nextTick(() => {
                        this.chatScrollBottomMethod();
                        const messageInputDom = document.querySelector('#chat-message-reply-input');
                        const messageSubmitDom = document.querySelector('#chat-message-reply-submit');

                        if (messageInputDom) {
                            // Remove previous listeners to prevent duplicates
                            if (this._keydownListener) {
                                messageInputDom.removeEventListener('keydown', this._keydownListener);
                            }
                            if (this._keyupListener) {
                                messageInputDom.removeEventListener('keyup', this._keyupListener);
                            }

                            // Attach new listeners (using arrow functions to preserve 'this')
                            this._keydownListener = (event) => {
                                if (event.key === 'PageUp' || event.key === 'PageDown') {
                                    const cursorPosition = event.key === 'PageUp' ? 0 : event.target.textLength;
                                    event.preventDefault();
                                    event.target.setSelectionRange(cursorPosition, cursorPosition);
                                }
                            };
                            messageInputDom.addEventListener('keydown', this._keydownListener);

                            // Declare typingTimeout as a component property
                            this._keyupListener = (event) => {
                                this.msgValue = messageInputDom.value;
                                this.messageContentDraftValue = messageInputDom.value; // Keep this consistent

                                if (this.selection_type === 'press_enter') {
                                    if (event.keyCode === 13) {
                                        if (event.shiftKey) {
                                            event.stopPropagation();
                                        } else if (!event.shiftKey) {
                                            event.preventDefault();
                                            if (messageSubmitDom) {
                                                messageSubmitDom.click();
                                            }
                                        }
                                    } else {
                                        // if (messageInputDom.value.length > 0) {
                                        //     commonSocketConnectMethod.emit({
                                        //         type: "TypingEventForChat",
                                        //         message: 'typing',
                                        //         ChatRoomId: chatRoomInfo.ticket_number
                                        //     });
                                        //     clearTimeout(this.typingTimeout); // Clear previous timeout using component property
                                        //     this.typingTimeout = setTimeout(() => { // Assign to component property
                                        //         commonSocketConnectMethod.emit({
                                        //             type: "TypingEventForChat",
                                        //             message: 'stop',
                                        //             ChatRoomId: chatRoomInfo.ticket_number
                                        //         });
                                        //     }, 2000);
                                        // }
                                    }
                                }
                            };
                            messageInputDom.addEventListener('keyup', this._keyupListener);

                            messageInputDom.focus();
                        }

                        if (messageSubmitDom) {
                            // Remove previous listeners to prevent duplicates
                            if (this._submitClickListener) {
                                messageSubmitDom.removeEventListener('click', this._submitClickListener);
                            }

                            this._submitClickListener = (e) => {
                                const messageInputDom = document.querySelector('#chat-message-reply-input');
                                this.msgValue = messageInputDom ? messageInputDom.value : '';
                                const message = this.msgValue;
                                const msg = message.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();

                                if (msg !== "") {
                                    const payload = {
                                        chatRoomId: chatRoomInfo.ticket_number,
                                        message: message,
                                        senderName: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
                                    };

                                    // Ensure typing 'stop' is sent and timeout cleared before sending message
                                    // commonSocketConnectMethod.emit({
                                    //     type: "TypingEventForChat",
                                    //     message: 'stop',
                                    //     ChatRoomId: chatRoomInfo.ticket_number
                                    // });
                                    clearTimeout(this.typingTimeout); // Clear any pending typing timeout

                                    // Ensure chatSocketMethod is initialized and open before sending
                                    if (this.chatSocketMethod && this.chatSocketMethod.readyState === WebSocket.OPEN) {
                                        if (this.messageIdForReply) {
                                            this.chatSocketMethod.send(JSON.stringify({
                                                type: 'chat_message',
                                                message: {
                                                    content: message,
                                                    reply_to: this.messageIdForReply,
                                                }
                                            }));
                                        } else {
                                            this.chatSocketMethod.send(JSON.stringify({
                                                type: 'chat_message',
                                                message: message
                                            }));
                                        }
                                    } else {
                                        // console.warn("Chat WebSocket not open or not initialized. Message not sent.", this.chatSocketMethod);
                                        // Potentially queue message or show user a warning
                                    }

                                    bus.$emit('newChatMessage', payload);
                                    bus.$emit('selfFullChatListOrdChangedBus', chatRoomInfo.ticket_number);

                                    if (messageInputDom) {
                                        messageInputDom.value = '';
                                    }
                                    this.msgValue = '';
                                    this.messageContentDraftValue = '';
                                    this.cancelReplyMessageOnChatMethod();
                                }
                            };
                            messageSubmitDom.addEventListener('click', this._submitClickListener);
                        }
                    });
                    this.WebSocketConnectionMethod(chatRoomSocketId, token); // Call WebSocket connection method
                });
            }
        },

        WebSocketConnectionMethod(chatRoomSocketId, token) {

            this.chatSocketMethod = new WebSocket(
                'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
                '/ws/ticket/' + chatRoomSocketId + '/?token=' + token
            );

            this.chatSocketMethod.onopen = () => {
                // console.log('Chat WebSocket opened for room:', chatRoomSocketId);
                pingInterval = setInterval(() => {
                if (this.chatSocketMethod.readyState === WebSocket.OPEN) {
                    this.chatSocketMethod.send(JSON.stringify({ type: 'ping' })); // Send a ping message
                }
                }, 30000); 
            };

            this.chatSocketMethod.onmessage = (e) => {
                this.renderLiveMessageMethod(e);
            };

            this.chatSocketMethod.onclose = (e) => {
                // console.error("WebSocket Close");
                clearInterval(pingInterval);
                this.chatSocketMethod = null;
            };
            
            this.chatSocketMethod.onerror = (error) => {
                clearInterval(pingInterval);
                this.chatSocketMethod = null;
            };
        },

        renderLiveMessageMethod(e) {
            const data = JSON.parse(e.data);
            if(data.type == 'pong' || data.type == 'connection_established') {
             return;
            } else if (data.type == 'readStatus') {
                if (this.lastLiveMsgData) {
                    this.allMessageListMethod();
                }
                return;
            } else {
                const messagesList = document.getElementById('reply_msg_list');
                this.displayChatMessageMethod(data, messagesList);
            } // Ensure we only process chat messages
        },

        displayChatMessageMethod(data, messagesList) {
            const selfUserId = this.selfUserId; // Assuming 'this' context is correct
            const isSelf = data.sender_info.id === selfUserId;
            if(data.delete_for_everyone){
                if (!isSelf) {
                bus.$emit('MessageDeleteForChatOfAllNotification', data);
                }
             return;
            };
            const message = data.message;
            const messageElement = document.createElement('div');
            messageElement.classList.add('live_msg');
            messageElement.id = `chatMessageId${data.id}`;

            const messageContentWrapper = document.createElement('div');
            messageContentWrapper.classList.add(data.sender_info.id === selfUserId ? 'recieved' : 'sent');
            messageElement.appendChild(messageContentWrapper);

            const chatMessageBox = document.createElement('div');
            chatMessageBox.classList.add('chat_in_msg_box_wrp');
            messageContentWrapper.appendChild(chatMessageBox);

            // Add SenderName Label if applicable
            if (!isSelf) {
                // chatMessageBox.appendChild(this.createSenderName(data));
            }
            // Add Forwarded Label if applicable
            if (data.forwarded) {
                chatMessageBox.appendChild(this.createForwardedLabelMethod());
            }

            // Add Reply Feature if applicable
            if (data.reply_to_msg) {
                chatMessageBox.appendChild(this.createReplyInfoMethod(data)); // Assuming 'message' is accessible here
            }

            // Add Message Content (File, Link, or Text)
            chatMessageBox.appendChild(this.createMessageContentMethod(data));

            // Add Dropdown for Options
            // chatMessageBox.appendChild(this.createMessageOptionsDropdownMethod(data, this)); // Passing 'this' for context

            // Add Timestamp and Read Status
            const timeWrapper = document.createElement('span');
            timeWrapper.classList.add('msg_time_wrp');
            const timeElement = document.createElement('time');
            timeElement.classList.add('msg_time');
            timeElement.textContent = moment(data.updated_at).format('h:mm a');
            timeWrapper.appendChild(timeElement);
            chatMessageBox.appendChild(timeWrapper);

            if (data.sender_info.id === selfUserId) {
                timeElement.after(this.createReadStatusLabelMethod(data));
            }

            // Add Forward Multiple Checkbox
            messageElement.appendChild(this.createForwardCheckboxMethod(data, message, this));

            messagesList.appendChild(messageElement);
            this.chatScrollBottomMethod();
        },

        createSenderName(chatData) {
            const senderName = document.createElement("span");
            senderName.className = 'message_sender_name';
            senderName.style.color = chatData.sender.colour;
            senderName.textContent = chatData.sender.first_name + ' ' + chatData.sender.last_name;
            return senderName;
        },

        createForwardedLabelMethod() {
            const forwardedMsgText = document.createElement("span");
            forwardedMsgText.classList.add('forwarded_msg_text');
            const shareIcon = document.createElement("i");
            shareIcon.classList.add('fa', 'fa-share');
            const forwardedMsgContent = document.createElement("span");
            forwardedMsgContent.textContent = 'Forwarded';
            forwardedMsgText.appendChild(shareIcon);
            shareIcon.after(forwardedMsgContent);
            return forwardedMsgText;
        },

        createReplyInfoMethod(replyData) {
            const showMsgOfReplyWrp = document.createElement("span");
            showMsgOfReplyWrp.classList.add('show_msg_of_reply_wrp');
            showMsgOfReplyWrp.style.borderLeftColor = replyData.sender.colour;

            const showMsgOfReplyName = document.createElement("span");
            showMsgOfReplyName.classList.add('show_msg_of_reply_name');
            showMsgOfReplyName.style.color = replyData.sender.colour;
            showMsgOfReplyName.textContent = `${replyData.sender.first_name} ${replyData.sender.last_name}`;

            let showMsgOfReplyTxt = document.createElement("span");
            showMsgOfReplyTxt.classList.add('show_msg_of_reply_txt');
            if (replyData.reply_to_msg.forwarded) {
                if (replyData.reply_to_msg.forwarded_from.file) {
                    const link = document.createElement('a');
                    link.href = replyData.reply_to_msg.forwarded_from.file;
                    link.target = '_new';
                    link.textContent = this.getFileName(replyData.reply_to_msg.forwarded_from.file);
                    showMsgOfReplyTxt.appendChild(link);
                } else {
                    showMsgOfReplyTxt.textContent = replyData.reply_to_msg.forwarded_from.message;
                }
            } else {
                if (replyData.reply_to_msg.file) {
                    const link = document.createElement('a');
                    link.href = replyData.reply_to_msg.file;
                    link.target = '_new';
                    link.textContent = this.getFileName(replyData.reply_to_msg.file);
                    showMsgOfReplyTxt.appendChild(link);
                } else {
                    showMsgOfReplyTxt.textContent = replyData.reply_to_msg.message;
                }
            }
            showMsgOfReplyWrp.appendChild(showMsgOfReplyName);
            showMsgOfReplyName.after(showMsgOfReplyTxt);
            return showMsgOfReplyWrp;
        },
        createMessageContentMethod(data) {
            const contentWrapper = document.createElement('span');
            // Helper function to create and append a link element
            const createLinkElement = (href, textContent) => {
                const link = document.createElement('a');
                link.href = href;
                link.target = '_new';
                link.classList.add('hyper_link');
                link.textContent = textContent;
                return link;
            };

            // Helper function to create and append a text span
            const createTextSpan = (message) => {
                const textSpan = document.createElement('span');
                textSpan.classList.add('msg_link');
                textSpan.innerHTML = message;
                return textSpan;
            };

            // Helper function to handle file rendering
            const renderFile = (fileUrl, messageContent) => {
                const msgExt = fileUrl.substring(fileUrl.lastIndexOf('.') + 1).split('?')[0];
                const link = createLinkElement(fileUrl, ''); // Link text will be the image/file
                const fileIcon = document.createElement('img');
                fileIcon.classList.add('img-fluid');

                if (['png', 'PNG', 'jpeg', 'jpg', 'svg', 'gif', 'webp'].includes(msgExt)) {
                    fileIcon.src = fileUrl;
                    const imgContainer = document.createElement('span');
                    imgContainer.classList.add('msg_img_render_in_chat');
                    imgContainer.appendChild(link);
                    link.appendChild(fileIcon);
                    contentWrapper.appendChild(imgContainer);
                } else {
                    fileIcon.src = this.checkFileExtensionForChatMessage(fileUrl);
                    const fileRenderContainer = document.createElement('span');
                    fileRenderContainer.classList.add('msg_file_render_in_chat');
                    fileRenderContainer.appendChild(link);
                    link.appendChild(fileIcon);

                    const fileNameSpan = document.createElement('span');
                    fileNameSpan.classList.add('msg_file_name');
                    fileNameSpan.textContent = fileUrl.split('/').pop().split('?')[0]; // Use pop() for last segment
                    link.appendChild(fileNameSpan); // Append fileNameSpan to the link
                    contentWrapper.classList.add('msg_in_file');
                    contentWrapper.appendChild(fileRenderContainer);
                }

                // Append message content after the file/image, if it exists
                if (messageContent) {
                    if (messageContent.startsWith('http://') || messageContent.startsWith('https://')) {
                        contentWrapper.appendChild(createLinkElement(messageContent, messageContent));
                    } else {
                        contentWrapper.appendChild(createTextSpan(messageContent));
                    }
                }
            };
            
            if (data.forwarded) {
                if (data.forwarded_from.file) {
                    renderFile(data.forwarded_from.file, data.forwarded_from.message);
                } else if (data.forwarded_from.message) { // Only message, no file
                    if (data.forwarded_from.message.startsWith('http://') || data.forwarded_from.message.startsWith('https://')) {
                        contentWrapper.appendChild(createLinkElement(data.forwarded_from.message, data.forwarded_from.message));
                    } else {
                        contentWrapper.appendChild(createTextSpan(data.forwarded_from.message));
                    }
                }
            } else if (data.file) {
                renderFile(data.file, data.message);
            } else if (data.message) { // Only message, no file and not forwarded
                if (data.message.startsWith('http://') || data.message.startsWith('https://')) {
                    contentWrapper.appendChild(createLinkElement(data.message, data.message));
                } else {
                    contentWrapper.appendChild(createTextSpan(data.message));
                }
            }

            return contentWrapper;
        },
        createMessageOptionsDropdownMethod(data, self) {
            const dropdownDiv = document.createElement("div");
            dropdownDiv.classList.add('dropdown');

            const msgToggleOption = document.createElement("span");
            msgToggleOption.classList.add('msg_toggle_option');
            msgToggleOption.setAttribute("data-toggle", 'dropdown');

            const faChevronDown = document.createElement("i");
            faChevronDown.classList.add('fa', 'fa-chevron-down');
            msgToggleOption.appendChild(faChevronDown);
            dropdownDiv.appendChild(msgToggleOption);

            const dropdownMenu = document.createElement("ul");
            dropdownMenu.classList.add('dropdown-menu');
            msgToggleOption.after(dropdownMenu);

            const replyLi = document.createElement("li");
            replyLi.textContent = 'Reply';
            replyLi.onclick = function () {
                self.replyMessageOnChatMethod(data);
            };
            dropdownMenu.appendChild(replyLi);

            const forwardedMessageLi = document.createElement("li");
            forwardedMessageLi.textContent = 'Forward Message';
            forwardedMessageLi.onclick = function () {
                self.forwardLiveMsgToUserMethod(data);
            };
            dropdownMenu.appendChild(forwardedMessageLi);

            const deleteLi = document.createElement("li");
            deleteLi.textContent = 'Delete Message';
            deleteLi.onclick = function () {
                self.deteteMessageFromChatMethod(data.id, data.message, data.updated_at, data.sender_info.id);
            };
            dropdownMenu.appendChild(deleteLi);

            return dropdownDiv;
        },

        createForwardCheckboxMethod(data, currentMessage, self) {
            const radioLabel = document.createElement('label');
            radioLabel.classList.add('live_msg_f_label');
            radioLabel.setAttribute('for', 'msg_input' + data.id);

            const customCheckboxSpan = document.createElement('span');
            customCheckboxSpan.classList.add('custom_checkbox_span');

            const customCheckboxI = document.createElement('i');
            customCheckboxI.classList.add('fa', 'fa-check');
            customCheckboxSpan.appendChild(customCheckboxI);

            const radioInput = document.createElement('input');
            radioInput.type = 'checkbox';
            radioInput.id = 'msg_input' + data.id;
            radioInput.hidden = true;
            radioInput.onclick = function () {
                self.forwardMsgCheckboxMethod(currentMessage, data.id);
            };

            radioLabel.appendChild(radioInput);
            radioLabel.appendChild(customCheckboxSpan);
            return radioLabel;
        },

        createReadStatusLabelMethod(data) {
            this.lastLiveMsgData = data;
            const labelReadS = document.createElement("label");
            labelReadS.classList.add('chat_msg_send_received_action_wrp');
            const labelReadI = document.createElement("i");
            labelReadI.classList.add('msg_indication');
            const liveMsgs = document.querySelectorAll('.live_msg .msg_indication');
            const apiMsgs = document.querySelectorAll('.chat_msg_li .msg_indication');
            if (this.getMessageStatusMethod(data.message_statuses) == 'read') {
                labelReadI.setAttribute("class", 'msg_indication msg_read_ind');
                // Iterate over each element and add a new class
                liveMsgs.forEach(element => {
                    element.classList.remove('msg_sent_ind');
                    element.classList.add('msg_read_ind'); // Replace 'your-new-class' with the class you want to add
                })
                apiMsgs.forEach(element => {
                    element.classList.remove('msg_sent_ind');
                    element.classList.add('msg_read_ind'); // Replace 'your-new-class' with the class you want to add
                })
            } else if (this.getMessageStatusMethod(data.message_statuses) == 'delivered') {
                labelReadI.setAttribute("class", 'msg_indication msg_sent_ind');
                // Iterate over each element and add a new class
                liveMsgs.forEach(element => {
                    if (!element.classList.contains('msg_read_ind')) {
                        element.classList.remove('msg_unsent_ind');
                        element.classList.add('msg_sent_ind');
                    } // Replace 'your-new-class' with the class you want to add
                })
                apiMsgs.forEach(element => {
                    if (!element.classList.contains('msg_read_ind')) {
                        element.classList.remove('msg_unsent_ind');
                        element.classList.add('msg_sent_ind');
                    } // Replace 'your-new-class' with the class you want to add
                })
            } else {
                labelReadI.setAttribute("class", 'msg_indication msg_unsent_ind')
            }
            labelReadS.appendChild(labelReadI);
            return labelReadS;
        },
        /*
         * This Will File Sent In Chat Method Here
         */
        onInputClick(event) {
            event.target.value = ''
        },

        handleFileUpload(event) {
            this.imgSrc = ''
            if (event.target.files && event.target.files.length > 0) {
                this.uploadFile = event.target.files[0];
                this.filename = this.uploadFile.name
                if (event.target.files[0].type.split('/')[0] == 'image') {
                    if (typeof FileReader === 'function') {
                        const reader = new FileReader();
                        reader.onload = (event) => {
                            this.imgSrc = event.target.result;
                        };
                        reader.readAsDataURL(this.uploadFile);
                    } else {
                        alert('Sorry, FileReader API not supported');
                    }
                }
            }
        },


        cancelUploadFile() {
            this.uploadFile = null;
            this.filename = '';
            this.fileMessage = '';
            this.messageContentDraftValue = '';
            document.querySelector('#chat-message-reply-input').value = '';
            this.listLoading = false;
            this.uploadProgress = 0;
            this.submitted = false;
        },

        /*
         * This Will Check File Extension In Chat
         */
        checkFileExtensionForChatMessage(file) {
            let extension = file.substr((file.lastIndexOf('.') + 1));
            extension = extension.substring(0, extension.lastIndexOf("?"));
            switch (extension) {
                case 'zip':
                    return require('@/assets/images/filetype/zip.png');
                    break;
                case 'rar':
                    return require('@/assets/images/filetype/zip-1.png');
                    break;
                    break;
                case 'eps':
                    return require('@/assets/images/filetype/ai.png');
                    break;
                case 'pdf':
                    return require('@/assets/images/filetype/pdf.png');
                    break;
                case 'css':
                    return require('@/assets/images/filetype/css.png');
                    break;
                case 'csv':
                    return require('@/assets/images/filetype/csv.png');
                    break;
                case 'doc':
                    return require('@/assets/images/filetype/doc.png');
                    break;
                case 'docx':
                    return require('@/assets/images/filetype/doc.png');
                    break;
                case 'json':
                    return require('@/assets/images/filetype/json-file.png');
                    break;
                case 'ppt':
                    return require('@/assets/images/filetype/ppt.png');
                    break;
                case 'pptx':
                    return require('@/assets/images/filetype/ppt.png');
                    break;
                case 'txt':
                    return require('@/assets/images/filetype/txt.png');
                    break;
                case 'xls':
                    return require('@/assets/images/filetype/xls.png');
                    break;
                case 'xlsx':
                    return require('@/assets/images/filetype/xls.png');
                    break;
                case 'xml':
                    return require('@/assets/images/filetype/xml.png');
                    break;
                case 'xlsm':
                    return require('@/assets/images/filetype/xls.png');
                    break;
                case 'py':
                    return require('@/assets/images/filetype/python.png');
                case 'cpp':
                    return require('@/assets/images/filetype/cpp-file-format-symbol.png');
                    break;
                case 'vbb':
                    return require('@/assets/images/filetype/coding.png');
                    break;
                default:
                    return require('@/assets/images/filetype/d_file.png');
            }
        },

        /*
         * This Will Check File Extension In Chat
         */
        checkFileExtension(file) {
            let extension = file.substr((file.lastIndexOf('.') + 1));
            switch (extension) {
                case 'jpg':
                    return require('@/assets/images/filetype/jpg.png');
                    break;
                case 'jpeg':
                    return require('@/assets/images/filetype/jpg.png');
                    break;
                case 'png':
                    return require('@/assets/images/filetype/png.png');
                    break;
                case 'gif':
                    return require('@/assets/images/filetype/jpg.png');
                    break;
                case 'zip':
                    return require('@/assets/images/filetype/zip.png');
                    break;
                case 'rar':
                    return require('@/assets/images/filetype/zip-1.png');
                    break;
                    break;
                case 'eps':
                    return require('@/assets/images/filetype/ai.png');
                    break;
                case 'pdf':
                    return require('@/assets/images/filetype/pdf.png');
                    break;
                case 'css':
                    return require('@/assets/images/filetype/css.png');
                    break;
                case 'csv':
                    return require('@/assets/images/filetype/csv.png');
                    break;
                case 'doc':
                    return require('@/assets/images/filetype/doc.png');
                    break;
                case 'docx':
                    return require('@/assets/images/filetype/doc.png');
                    break;
                case 'json':
                    return require('@/assets/images/filetype/json-file.png');
                    break;
                case 'ppt':
                    return require('@/assets/images/filetype/ppt.png');
                    break;
                case 'pptx':
                    return require('@/assets/images/filetype/ppt.png');
                    break;
                case 'txt':
                    return require('@/assets/images/filetype/txt.png');
                    break;
                case 'xls':
                    return require('@/assets/images/filetype/xls.png');
                    break;
                case 'xlsx':
                    return require('@/assets/images/filetype/xls.png')
                    break;
                case 'xml':
                    return require('@/assets/images/filetype/xml.png');
                    break;
                case 'xlsm':
                    return require('@/assets/images/filetype/xls.png');
                    break;
                case 'py':
                    return require('@/assets/images/filetype/python.png');
                case 'cpp':
                    return require('@/assets/images/filetype/cpp-file-format-symbol.png');
                    break;
                case 'vbb':
                    return require('@/assets/images/filetype/coding.png');
                    break;
                default:
                    return require('@/assets/images/filetype/d_file.png');
            }
        },

        /*
         * This Will Check File Submitted In MSG Method Here
         */
        fileMsgSubmitMethod() {
            this.submitted = true
            let formData = new FormData();

            formData.append('chat_room_user', this.selectedRoomInfo.ticket_number);
            formData.append('message', this.fileMessage);
            formData.append('file', this.uploadFile);
            formData.append('filename', this.filename);

            this.listLoading = true;

            axios.post(UploadMsgFileURL, formData, {
                onUploadProgress: progressEvent => {
                    this.uploadProgress = Math.round(
                        (progressEvent.loaded / progressEvent.total) * 100
                    );
                },
            }).then((res) => {
                const messageId = res.data.data.id;
                this.chatSocketMethod.send(JSON.stringify({
                    type: 'file_upload',
                    message_id: messageId
                }));
                const payload = {
                    chatRoomId: this.selectedRoomInfo.ticket_number
                };
                bus.$emit('newChatMessage', payload);
                this.cancelUploadFile();
            }).catch((err) => {
                toast.error(err.data.msg);
                this.listLoading = false;
                this.uploadProgress = 0;
                this.submitted = false;
            })
        },

        fileOpenNewTab(href) {
            window.open(href, '_blank');
        },
        /*
         * This Will Check Blocked User Method Here
         */
        replaceURLsInMsgText(message) {
            if (!message) return;
            var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
            return message.replace(urlRegex, function (url) {
                var hyperlink = url;
                if (!hyperlink.match('^https?:\/\/')) {
                    hyperlink = 'http://' + hyperlink;
                }
                return '<a href="' + hyperlink + '" class="hyper_link" target="_blank">' + url + '</a>'
            });
        }
    },
    watch: {
        getSelectedChatRoomInfo(newVal, oldVal) {
            this.selectedRoomInfo = newVal;
            if (!this.selectedRoomInfo) return;
            this.multiMessageOptionEnabled = false;
            this.multipleMessageArr = [];
            this.buildChatRoomMethod(newVal);
        },
        getSelfUserInfo() {
            return this.$store.getters.acUserDetailsStateGetters;
        },
    },
}
</script>

<style lang="scss" scoped>
.content {
    float: left;
    height: 100%;
    overflow: hidden;
    position: relative;
    border-right: 1px solid rgba(35, 35, 35, 0.4);

    .contact-profile {
        width: 100%;
        height: 60px;
        padding-top: 10px;
        background: #111111;

        .selected_user_details {
            img {
                width: 40px;
                border-radius: 50%;
                float: left;
                margin: 0;
                height: 40px;
                object-fit: cover;
                object-position: top center;
            }
        }

        p {
            margin: 0px;
            color: #ffffff;
            line-height: 1;
            font-size: 18px;
        }
    }

    .messages {
        height: auto;
        min-height: calc(100dvh - 270px);
        max-height: calc(100dvh - 270px);
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        position: relative;

        .list_msg_of_chat>ul {
            width: 100%;
            float: left;
            padding: 0px;
            margin: 0px;
            // display: flex;
            // flex-wrap: wrap-reverse;
        }

        &::-webkit-scrollbar {
            width: 8px;
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #333333;
        }
    }

    .message-input {
        position: absolute;
        bottom: 0;
        width: 100%;

        .wrap {
            position: relative;
            z-index: 100;

            input,
            textarea {
                font-family: "proxima-nova", "Source Sans Pro", sans-serif;
                float: left;
                border: none;
                width: 100%;
                padding: 10px 32px 10px 22px;
                font-size: 15px;
                color: #fff;
                background: #111;
                line-height: 1.3;
                height: 90px;
                outline: none !important;
                resize: none;
                -ms-overflow-style: none;
                overflow: -moz-scrollbars-none;

                &::-webkit-scrollbar,
                &::-webkit-scrollbar {
                    display: none;
                }
            }

            .option_btn_wrp {
                button {
                    border: none;
                    width: 100%;
                    cursor: pointer;
                    background: #232323;
                    color: #ffffff;
                    height: calc(100% - 24px);
                    outline: none !important;

                    &:hover {
                        background: #87cefa;
                        color: #000;

                        path {
                            fill: #000000 !important;
                        }
                    }
                }
            }

        }
    }

    .fixloader.msgloader {
        position: absolute;
        top: 0;
        width: 150px;
        height: 70px;
        left: 0;
        right: 0;
        margin: 0 auto;
        background: #000000;

        .spinner {
            width: 65px;
            height: 65px;

            &::after {
                width: 35px;
                height: 35px;
            }

            &::before {
                width: 65px;
                height: 65px;
            }
        }
    }
}

.msg_file_upload {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    margin-bottom: 0px;
    position: relative;

    input[type="file"] {
        position: absolute;
        opacity: 0;
        visibility: hidden;
    }

    .img-fluid {
        max-width: 28px;
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);

        &:hover {
            filter: drop-shadow(0 0 5px #ff00de);
            transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -moz-transform: scale(1.1);
        }
    }
}

.msg_file_wrp {
    position: absolute;
    top: 60px;
    background: #0e0e0e;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
}

.listLoading {
    z-index: 1000;
}

.msg_file_top_wrp {
    background: lightskyblue;
    color: #000;
    padding: 10px 20px;
    display: flex;
    align-items: revert;

    span {
        font-size: 16px;
        line-height: 1;
    }
}

.uploaded_file_preview {
    width: 300px;
    height: 270px;
    margin: 30px auto;
    text-align: center;

    .img-fluid {
        object-fit: cover;
        height: 100%;
        object-position: center center;
    }
}


.msg_file_popup_close {
    cursor: pointer;
    margin-right: 8px;

    .fa {
        font-size: 18px;
        color: #000000;

        &:hover {
            color: #ff4338;
        }
    }
}

.ws_common_modal {
    position: fixed;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.92);
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    padding: 10px;
    align-items: center;

    .ws_common_modal_body {
        background: #000;
        width: 100%;
        margin: 0px auto;
        border-radius: 5px;
        padding: 20px 15px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        max-width: 580px;
        color: #ffffff;
        -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    }

    .ws_common_modal_header h2 {
        font-size: 18px;
        color: #ffffff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-align: center;
        margin: 0 0 30px;
    }

    .btn {
        font-size: 16px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 10px 5px;
        min-width: 100px;
        line-height: 1;
        border-radius: 3px;
        outline: none !important;
        border: none !important;
        box-shadow: none !important;

        &:hover {
            background: #ffe738 !important;
            color: #22292f !important;
        }
    }

    .remove_yes_btn {
        background: rgba(255, 18, 18, 0.5);
        color: #fff;
    }

    .remove_yes_no {
        background: rgba(33, 228, 0, 0.5);
        color: #fff;
    }
}

.msg_date_wrp {
    text-align: center;
    margin: 10px 0px 15px !important;
    position: relative;

    &::before {
        content: "";
        height: 1px;
        background: rgba(255, 255, 255, 0.28);
        position: absolute;
        left: -25px;
        right: -25px;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
    }

    span {
        &.msg_date_box {
            background: #ffc107;
            color: #000;
            border-radius: 3px;
            padding: 2px 6px !important;
            z-index: 100;
            font-weight: 500;
            font-size: 15px;
            line-height: 1;
            position: relative;
        }
    }
}

.chat_msg_list_wrp {
    position: absolute;
    top: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 5px 30px;

    &::-webkit-scrollbar {
        width: 8px;
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #333333;
    }

    .extra_space {
        flex: 1 1 auto;
    }
}

.pinned_icon_wrp {
    display: inline-block;
    vertical-align: middle;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);

    .fa {
        font-size: 26px;
        color: #d6d6d6;
        cursor: pointer;
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);

        &:hover {
            text-shadow: 0 0 5px #ff00de;
            transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -moz-transform: scale(1.1);
        }

        @media only screen and (max-width: 768px) {
            font-size: 20px;
            margin: 0 10px;
        }
    }

    &.room_pinned {
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);

        .fa {
            color: #00efd1;
        }
    }
}

.option_btn_wrp {
    float: right;
    width: 50px;
    background: #232323;
    height: 90px;
    position: relative;

    .option_btn_icon_wrp {
        text-align: center;

        svg {
            cursor: pointer;

            &.actv_btn {
                path {
                    fill: #ffc107;
                }
            }
        }
    }

    .option_btn_content_wrp {
        position: absolute;
        bottom: 25px;
        right: 0;
        width: 265px;
        background: rgba(52, 57, 60, 0.98);
        border-radius: 5px;
        z-index: 1000;
        text-align: left;
        padding: 10px;

        ul {
            margin: 0px;

            input[type="radio"] {
                display: none;
            }

            .option_content_heading {
                display: block;
                font-size: 16px;
                color: #f3f3f3;
                font-weight: 500;
            }

            .option_content_normal_txt {
                color: #f3f3f3;
                font-size: 14px;
            }

            li {
                label {
                    position: relative;
                    padding-left: 28px;
                    margin-bottom: 12px;
                    letter-spacing: 0.3px;

                    &:before {
                        content: "";
                        width: 20px;
                        height: 20px;
                        border: 1px solid #f3f3f3;
                        position: absolute;
                        border-radius: 50%;
                        left: 0;
                        top: 6px;
                        transition-property: box-shadow;
                        transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
                        transition-duration: 167ms;
                        cursor: pointer;
                    }

                    &:hover {
                        &:before {
                            box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
                        }
                    }

                    &.active {
                        &:before {
                            background: #7ac70c;
                            border-color: #7ac70c;
                        }
                    }
                }

                &:last-child {
                    label {
                        margin-bottom: 0px;
                    }
                }
            }
        }
    }
}

.file_send_in_msg_wrp input,
.file_send_in_msg_wrp textarea {
    font-family: "proxima-nova", "Source Sans Pro", sans-serif;
    float: left;
    border: none;
    width: calc(100% - 50px);
    padding: 10px 22px;
    font-size: 15px;
    color: #fff;
    background: #111;
    line-height: 1.3;
    height: 90px;
    outline: none;
    resize: none;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
}

.file_send_in_msg_wrp input::-webkit-scrollbar,
.file_send_in_msg_wrp textarea::-webkit-scrollbar {
    display: none;
}

.file_send_in_msg_wrp {
    button {
        border: none;
        width: 50px;
        cursor: pointer;
        background: #232323;
        color: #ffffff;
        height: 90px;

        &:hover {
            background: #87cefa;
            color: #000;

            path {
                fill: #000000 !important;
            }
        }
    }
}

.reply_msg_detail_view_wrp {
    background: #111;
    padding: 5px 20px 0px;

    .reply_msg_data_wrp {
        background: #232323;
        padding: 5px 10px;
        border-radius: 5px;
        border-left: 3px solid #87cefa;
    }

    .reply_msg_data_close {
        .img-fluid {
            max-width: 20px;
            cursor: pointer;
        }
    }

    .reply_msg_file_wrp {
        display: flex;
        align-items: center;
        margin-top: 5px;

        .img-fluid {
            width: 25px;
            margin-right: 5px;
        }
    }
}

.show_msg_of_reply_wrp {
    background: rgba(255, 217, 222, 0.44);
    padding: 3px 8px;
    border-radius: 5px;
    border-left: 3px solid rgba(135, 206, 250, 0.55);
    display: block;
    margin: 0px -5px 3px;
    font-weight: normal;

    .show_msg_of_reply_name {
        display: block;
        color: #565656;
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 2px;
        line-height: 1;
    }

    .show_msg_of_reply_txt {
        color: #6f6f6f;
        font-size: 13px;

        a {
            color: #6f6f6f;
            text-decoration: none;
        }
    }
}

.typing_dots_wrp {
    height: 20px;
}


.content.reply_msg_for_scroll_height_reduce .messages {
    min-height: calc(100dvh - 320px);
    max-height: calc(100dvh - 320px);
}

.missed_call_msg_show_wrp {
    text-align: center;
    padding: 2px 0;

    .missed_call_msg_box_wrp {
        padding: 5px 12px 6px;
        text-align: center;
        background-color: #b1d4e5;
        border-radius: 4.5px;
        box-shadow: 0 1px 0.5px rgba(255, 255, 255, 0.5);
        display: inline-block;

        svg {
            color: #df3333;
            margin-right: 7px;
        }

        span {
            font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
            color: #000;
            font-size: 14px;
            font-weight: 500;
        }
    }
}

.recieved .missed_call_msg_box_wrp {
    background-color: #ffb6c1;
}

.forwarded_msg_text {
    display: block;
    text-align: left;

    &>span {
        display: inline-block;
        vertical-align: middle;
        margin-left: 3px;
        font-weight: normal;
        font-style: italic;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
        font-family: arial;
    }

    svg {
        display: inline-block;
        vertical-align: middle;
    }

    .fa {
        color: rgba(0, 0, 0, 0.5);
        font-size: 14px;
        display: inline-block;
        vertical-align: middle;
    }
}


.workspace_user_info_link {
    a {
        text-decoration: none;
    }
}

.msg_searchbar {
    svg {
        cursor: pointer;
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);

        @media only screen and (max-width: 768px) {
            width: 20px;
            height: 20px;
            margin-right: 5px;
        }

        &:hover {
            transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -moz-transform: scale(1.1);
            filter: drop-shadow(0 0 5px #ff00de);
            -webkit-filter: drop-shadow(0 0 5px #ff00de);
            -moz-filter: drop-shadow(0 0 5px #ff00de);
        }
    }
}

.msg_file_upload {
    .fa {
        font-size: 26px;
        color: #d6d6d6;
        cursor: pointer;
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);

        @media only screen and (max-width: 768px) {
            font-size: 20px;
        }

        &:hover {
            text-shadow: 0 0 5px #ff00de;
            transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -moz-transform: scale(1.1);
        }
    }
}

.block_action_btn {
    text-align: center;
    font-family: 'AceSansDemo';
    font-size: 14px;
    display: inline-block;
    padding: 7px 10px;
    letter-spacing: 1px;
    border-radius: 3px;
    min-width: 70px;
    border: none;
    line-height: 1;
    outline: none;
    box-shadow: none;
    border: 2px solid #ff4338 !important;
    color: #ffffff !important;
    background: none !important;
    font-weight: bold;
    box-shadow: none !important;
    outline: none !important;

    &:hover {
        background: #ffd400 !important;
        color: #000000 !important;
        border-color: #ffd400 !important;
    }

    @media only screen and (max-width: 768px) {
        font-size: 12px;
        padding: 5px;
        min-width: 60px;
    }
}

.blank_message_input_box {
    background: #111;
    height: 90px;
}

.msg_f_label {
    margin: 0;
    position: absolute;
    top: 50%;
    left: -24px;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    width: 16px;
    height: 16px;

    .custom_checkbox_span {
        display: flex;
        width: 16px;
        height: 16px;
        border: 2px solid #ffc107;
        border-radius: 2px;
        line-height: 16px;
        // align-items:center;
        justify-content: center;
        cursor: pointer;

        .fa {
            color: #000000;
            font-size: 0px;
        }
    }

    input[type="checkbox"]:checked+.custom_checkbox_span {
        background-color: #ffc107;
        border-color: #ffc107;

        .fa {
            font-size: 14px;
            line-height: 1;
        }
    }
}

.forward_msg_action {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    height: 90px;
    background: #111111;
    padding: 30px 20px 0px;

    span {
        display: inline-block;
        vertical-align: middle;

        &.f_m_selected {
            color: #ffc107;
            font-size: 16px;
            line-height: 1;
        }
    }

    .fa {
        font-size: 24px;
        vertical-align: middle;
        line-height: 1;
        cursor: pointer;

        &.fa-close:hover {
            color: #ff4338;
        }

        &.fa-share:hover {
            color: #ffc107;
        }
    }
}

.messages li {
    position: relative;
}

.message_insert_box {
    position: relative;
    width: calc(100% - 50px);

    .emoji-invoker {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.2s;
        padding: 0;
        background: transparent;
        border: 0;
    }

    .emoji-invoker:hover {
        transform: scale(1.1);

        svg {
            fill: #ffc107;
        }
    }

    .emoji-invoker>svg {
        fill: #545555;
        width: 30px;
        height: 30px
    }

    .emoji-picker {
        position: absolute;
        z-index: 1;
        font-family: 'Montserrat', sans-serif;
        border: 1px solid #2b2b2b;
        height: auto;
        overflow: auto;
        padding: 10px 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 50px;
        background: #1d2226;
        /* -webkit-box-shadow: 1px 1px 8px #c7dbe6; */
        /* box-shadow: 1px 1px 8px #c7dbe6; */
        right: 0px;
        bottom: 0px;
    }

    .emoji-picker__search {
        display: flex;
    }

    .emoji-picker__search>input {
        flex: 1;
        border-radius: 10rem;
        border: 1px solid #ccc;
        padding: 0.5rem 1rem;
        outline: none;
    }

    .emoji-picker h5 {
        margin-bottom: 0;
        color: #b1b1b1;
        text-transform: uppercase;
        font-size: 0.8rem;
        cursor: default;
    }

    .emoji-picker .emojis {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .emoji-picker .emojis:after {
        content: "";
        flex: auto;
    }

    .emoji-picker .emojis span {
        padding: 0 2px;
        cursor: pointer;
        border-radius: 2px;
        font-size: 18px;
    }

    .emoji-picker .emojis span:hover {
        background: rgba(5, 5, 5, 0.15);
        cursor: pointer;
    }

}

@media only screen and (min-width:768px) and (max-width:1310px) {
    .content .contact-profile p {
        font-size: 16px;
    }
}

@media only screen and (max-width: 768px) {
    .usr-photo {
        padding-left: 10px;
    }

    .content .contact-profile p {
        font-size: 16px;
    }
}
</style>